import { useMemo } from 'react';

export function useRequest({ action, type, filter = {} }) {
  const stringifiedFilter = JSON.stringify(filter);
  const parsedFilter = useMemo(
    () => JSON.parse(stringifiedFilter),
    [stringifiedFilter],
  );

  const stringifiedAction = JSON.stringify(action);
  const parsedAction = useMemo(
    () => JSON.parse(stringifiedAction),
    [stringifiedAction],
  );

  const request = useMemo(
    () => ({
      action: parsedAction,
      type,
      filter: parsedFilter,
    }),
    [parsedAction, type, parsedFilter],
  );

  return request;
}
